import { DataCache, QueryResultsRelationship, SharedKeyRelationship, ForeignKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';

import { VesselPortCallRequestOptions } from 'data/models/VesselPortCallRequest';
import { VesselPortCallResponse } from 'data/models/VesselPortCallResponse';

export class VesselPortCallsCache extends DataCache {
    VesselPortCallResponses = PCCollection(VesselPortCallResponse);

    constructor(data : PCCache) {
        super();
        new ForeignKeyRelationship(data.Vessels, this.VesselPortCallResponses, null, e => e.Vessel, e => e.VesselId());
        new QueryResultsRelationship(this.VesselPortCallResponses, data.PortCalls, r => r.PortCalls);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/vesselportcalls/cache.ts